module.exports = __webpack_public_path__ + "static/img/ba-single.eb46d1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/ba-single.svg
// module id = ubXZ
// module chunks = 8